// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__GoVr5","wrapperOpened":"styles_wrapperOpened__3MSpi","inner":"styles_inner__bCKKU","iconWrap":"styles_iconWrap__pjGzI","content":"styles_content__BXEXG","action":"styles_action__00Ty6"};
module.exports.__checksum = "ffad316f3360"